import { schema as normalizrSchema } from 'normalizr';

export const schema = new normalizrSchema.Entity('board', {}, { idAttribute: entity => entity.id || entity.basic.id });
export const schemasArray = new normalizrSchema.Array(schema);
